export default "/images/0d775349d6885780034893b7ea42ea88.jpg";